import React from "react";

export const CourierDetailBox = ({courierName, courierTckn, courierCellPhone}) => {
    return (
        <div style={{display: "flex", flexDirection: "column"}}>
            <div style={{display: "flex"}}>
                <h4 style={{fontWeight: "bold"}}>{" " + courierName} </h4>
            </div>
            <div style={{display: "flex", gap: "5px"}}>
                <h4 style={{fontWeight: "bold"}}>TCKN: </h4>
                <span> {courierTckn}</span>
            </div>
            <div style={{display: "flex", gap: "5px"}}>
                <h4 style={{fontWeight: "bold"}}>Telefon: </h4>
                <span> {courierCellPhone}</span>
            </div>
        </div>
    );
};
